module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtMasterMsspSix.37a0886.png";